import { FormOption } from 'common/form/types/Form';

export const CLOSE_CONVERSATION_CUSTOM_VALUE = 'CUSTOM';

export const CLOSE_CONVERSATION_OPTIONS: FormOption[] = [
  {
    label: '1 day',
    value: '24'
  },
  {
    label: '2 days',
    value: '48'
  },
  {
    label: '7 days',
    value: '168'
  },
  {
    label: 'Custom',
    value: CLOSE_CONVERSATION_CUSTOM_VALUE
  }
];
